import auth from "../../../web-sh/src/pages/auth/components";

import CreateMPConfirmModal from "./CreateMPConfirm";
import GetMPHintModal from "./GetMPHint";
import JoinEnterprise from "./JoinEnterprise";
import AuthCard from "./AuthCard";

auth.AuthCard = AuthCard

const authComponents = {
  ...auth,
  CreateMPConfirmModal,
  GetMPHintModal,
  JoinEnterprise
}

export default authComponents